import React from "react";
import Input from "../input/Input";
import { ComposantAllProps } from "composants/common";
import { format } from "date-fns";
import { useMacOSDatePicker } from "utils/platform.utils";

export interface CalendarHoursProps extends ComposantAllProps {
  defaultAppearance?: boolean;
}

export const CalendarHours = ({ value, defaultAppearance, ...restProps }: CalendarHoursProps) => {
  const finalValue = value ? format(value, "yyyy-MM-dd'T'HH:mm") : "";
  const { inputRef, isMacOS, handleFocus, handleMouseDown } = useMacOSDatePicker();

  return (
    <Input
      {...restProps}
      ref={inputRef}
      data-initial-appearance={defaultAppearance || isMacOS}
      type="datetime-local"
      value={finalValue}
      data-value={finalValue}
      max="9999-12-31T23:59"
      onFocus={(e) => handleFocus(e, restProps.onFocus)}
      onMouseDown={(e) => handleMouseDown(e, restProps.onMouseDown)}
    />
  );
};

export default CalendarHours;
